<template>
  <Component />
  <!-- <button type="button" @click="login">123</button> -->
</template>

<script>
import Component from '@/components/receive_page/receive_edit_view_delete.vue';

export default {
    components: {
        Component
    },
}
</script>